import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код версии отчетной формы',
    key: 'code_version',
    width: 250,
    fixedLeft: true,
  },
  {
    title: 'Наименование версии отчетной формы',
    key: 'report_version_name',
    width: 250,
  },
  {
    title: 'Таблица-источник для построения отчета',
    key: 'table_source',
    width: 240,
  },
  {
    title: 'Таблица-источник клиента',
    key: 'table_source_client',
    width: 200,
  },
  {
    title: 'Таблица-получатель',
    key: 'table_receiver',
    width: 210,
  },
  {
    title: 'Источник для отображения отчета на UI',
    key: 'ui_table_source',
    width: 250,
  },
  {
    title: 'Процедура наполнения отчета',
    key: 'script',
    width: 250,
  },
  {
    title: 'Тип отчета',
    key: 'url',
    width: 210,
  },
  {
    title: 'Параметр 1 для URL',
    key: 'url_p1',
    width: 210,
  },
  {
    title: 'Параметр 2 для URL',
    key: 'url_p2',
    width: 210,
  },
  {
    title: 'Параметр 3 для URL',
    key: 'url_p3',
    width: 210,
  },
  {
    title: 'Параметр 4 для URL',
    key: 'url_p4',
    width: 210,
  },
  {
    title: 'Параметр 5 для URL',
    key: 'url_p5',
    width: 210,
  },
  {
    title: 'Параметр 6 для URL',
    key: 'url_p6',
    width: 210,
  },
  {
    title: 'Параметр 7 для URL',
    key: 'url_p7',
    width: 210,
  },
  {
    title: 'Параметр 8 для URL',
    key: 'url_p8',
    width: 210,
  },
  {
    title: 'Параметр 9 для URL',
    key: 'url_p9',
    width: 210,
  },
  {
    title: 'Параметр 10 для URL',
    key: 'url_p10',
    width: 220,
  },
  {
    title: 'Округление значений',
    key: 'rounded',
    render: ({ value }) => value && <Icon name="check" />,
    width: 200,
  },
  {
    title: 'Отображать в структуре отчетности',
    key: 'is_report_structure_visible',
    render: ({ value }) => value && <Icon name="check" />,
    width: 220,
  },
  {
    title: 'Отображать в реестре публикаций',
    key: 'is_report_publish_visible',
    render: ({ value }) => value && <Icon name="check" />,
    width: 220,
  },
  {
    title: 'Дельта-подход',
    key: 'is_delta_approach',
    render: ({ value }) => value && <Icon name="check" />,
    width: 220,
  },
  {
    key: 'organization_code',
    hidden: true,
  },
  {
    key: 'report_version_code',
    hidden: true,
  },
  {
    key: 'report_version',
    hidden: true,
  },
];
